import { SystemEntity } from './shared-api-models';

export enum PartyRoleType {
    Adviser = SystemEntity.Adviser,
    Client = SystemEntity.Client,
    Intermediary = SystemEntity.Intermediary,
    Lead = SystemEntity.Lead,
    ProductProvider = SystemEntity.ProductProvider,
}
